export const SITE_BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL ?? 'https://newtonik.ru';

export const LOGO_URL =
  'https://storage.yandexcloud.net/newtonik/metadata/logo.png';

export const APP_URLS = {
  signUpBaseUrl: '/sign-up',
  signUpChoosePlanUrl: '/sign-up/choose-plan',
  signUpCreateAccountUrl: '/sign-up/create-account',
  signUpPaymentUrl: '/sign-up/payment',
  paymentResultUrl: '/payment-result',
  promoSuccess: '/sign-up/success',
  myAccountSubscriptionManagement: '/myaccount/subscription',
  myAccount: '/myaccount/general'
};

export const SUCCESS_PAGES = [APP_URLS.paymentResultUrl, APP_URLS.promoSuccess];

export const SIGN_UP_ROUTES = ['create-account', 'payment'];

export const PREMIUM_ROUTES = ['premium'];
export const ACCOUNT_ROUTES = ['myaccount'];
export const PROTECTED_ROUTES = ['premium', 'myaccount'];
